export default __webpack_public_path__ + "static/media/Responsive_Love_and_Happiness.f860b150.webp";